'use client';

import type { FindingSeverityType } from '@terra/shared-schemas-orchestrator';
import { useTranslations } from 'next-intl';
import {
  buildFindingSeverityPostureItems,
  sumPostureCounts,
} from './posture-items';
import { PostureCard } from './PostureCard';
import { useOpenListFromHome } from './useOpenListFromHome';

const NO_FINDINGS: Record<FindingSeverityType, number> = {
  Critical: 0,
  High: 0,
  Medium: 0,
  Low: 0,
  Info: 0,
};

type FindingsSeverityPostureCardProps = {
  applicationId: string;
  counts: Record<FindingSeverityType, number> | undefined;
  isLoading: boolean;
};

export function FindingsSeverityPostureCard({
  applicationId,
  counts,
  isLoading,
}: FindingsSeverityPostureCardProps) {
  const t = useTranslations('home.posture');
  const { openList, openListContextMenu } = useOpenListFromHome({
    applicationId,
  });
  const items = buildFindingSeverityPostureItems({
    counts: counts ?? NO_FINDINGS,
  }).map((item) => ({ ...item, label: t(`severity.${item.key}`) }));

  return (
    <PostureCard<FindingSeverityType>
      title={t('findingsBySeverity')}
      total={sumPostureCounts(items)}
      items={items}
      isLoading={isLoading}
      emptyLabel={t('noFindings')}
      onSelect={(severity) =>
        openList({ list: 'findings', filters: { severityFilter: [severity] } })
      }
      onTitleClick={() =>
        openList({ list: 'findings', filters: { severityFilter: [] } })
      }
      onTitleContextMenu={(event) =>
        openListContextMenu(event, { list: 'findings' })
      }
    />
  );
}
